import { create } from 'zustand';
import { ReceiptData } from 'types';

interface ReceiptState {
  receiptData: ReceiptData | null;
  setReceiptData: (data: ReceiptData | null) => void;
  reset: () => void;
}

export const useReceiptStore = create<ReceiptState>((set) => ({
  receiptData: null,
  setReceiptData: (data: ReceiptData | null) => set({ receiptData: data }),
  reset: () => set({ receiptData: null }),
}));
